import { render, staticRenderFns } from "./MemberRoleFilterComponent.vue?vue&type=template&id=0530bcda&scoped=true&"
import script from "./MemberRoleFilterComponent.vue?vue&type=script&lang=js&"
export * from "./MemberRoleFilterComponent.vue?vue&type=script&lang=js&"
import style0 from "./MemberRoleFilterComponent.vue?vue&type=style&index=0&id=0530bcda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0530bcda",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0530bcda')) {
      api.createRecord('0530bcda', component.options)
    } else {
      api.reload('0530bcda', component.options)
    }
    module.hot.accept("./MemberRoleFilterComponent.vue?vue&type=template&id=0530bcda&scoped=true&", function () {
      api.rerender('0530bcda', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/TeamMembers/components/MemberRoleFilterComponent.vue"
export default component.exports